<template>
	<div class="element-sum is-empty">
		<div class="element-sum-container">
			<div class="badge" :class="[options('style'), options('color'), classes()]">
				<span class="value">{{value}}</span>
				<span class="label" v-html="macro(label)"></span>
			</div>
		</div>
	</div>
</template>

<script>
	import _uniqWith from 'lodash/uniqWith'
	import store from '../../store'
	import util from '../../../../elements'

	export default {
		props: {
			definition: { type: Object, required: true },
			element:    { type: Object, required: true },
		},
		computed: {
			label () { let l = this.options('label'); return l && l.substring(0,2) == '%|' ? l.substring(2) : l },
			type  () {
				if (this.options('label').substr(0,2) == '%|') { return 'PERCENTAGE' }
				if (this.source && this.source.type == 'CALCULATED') {
					return this.source.options && this.source.options.type ? this.source.options.type : 'NUMERIC'
				}
				return this.source && this.source.type ? this.source.type : 'NUMERIC'
			},
			source() { 
				return this.options('source') ? store.state.template.elements.find(e => e.id == this.options('source')) : null 
			},
			elements() {
				let group = store.state.template.groups.find(g => g.id == this.definition.group)
				let result = this.source ? store.state.elements.filter(e => e.definition == this.source.id) : []
				if (group && store.state.template.panels.find(p => p.id == group.panel && p.type == 'INDIVIDUAL')) {
					let keys = store.state.panels.filter(p => p.type == 'ACCOUNT' || p.id == this.element.panel).map(p => p.id)
					result = result.filter(e => keys.indexOf(e.panel) != -1)
				}
				if (this.source && this.source.group == this.definition.group) {
					result = result.filter(e => e.group == this.element.group)
				}
				return _uniqWith(result, ((a,b) => a.panel + a.group == b.panel + b.group))
			},
			value() {
				if (!this.source) return 0
				let result = 0
				this.elements.forEach(e => {
					if (!isNaN(parseFloat(e.value))) {
						result += parseFloat(e.value)
					}
				})
				let defaults = {l: store.getters['language'], t: store.getters['timezone'], c: store.getters['currency']}
				return util[this.type].format(this.source, parseFloat(result).toFixed(2), defaults)
			},
		},
		methods: {
			classes()      { let p = store.state.theme.print.elements.input; return 'print--size-' + p.size + ' print--color-' + p.color },
			macro  (value) { return store.getters['macro'](value) },
			options(value) { return store.getters['options'](this.definition, value) },
		}
	}
</script>
